import { useRecentRoute } from '@/hooks/useRecentRoute';
import { SiteComparison } from './SiteComparison';
import styles from './SitePages.module.css';
export function SiteEarningsPage() {
  useRecentRoute('Earnings');
  return <div className={styles.page}><h1 className={styles.title}>Earnings</h1><p className={styles.muted}>Compare site financial activity. Payments to you are shown separately when verified.</p><SiteComparison financial /></div>;
}
export default SiteEarningsPage;
